import { Link } from "react-router-dom";
import ScrollReveal from "@/components/base/ScrollReveal";

export default function RecruitCta() {
  return (
    <section className="relative w-full overflow-hidden bg-foreground-950 py-24 md:py-32">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20modern%20architecture%20interior%20with%20strong%20geometric%20lines%2C%20monochrome%20concrete%20and%20glass%2C%20subtle%20warm%20golden%20highlights%2C%20minimalist%20elegant%20corporate%20photography%2C%20dramatic%20perspective%2C%20mostly%20dark%20tones%2C%20sophisticated%20calm%20mood&width=1920&height=1080&seq=revra-recruit-bg&orientation=landscape"
          alt="採用情報イメージ"
          className="h-full w-full object-cover opacity-40"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950 via-foreground-950/80 to-foreground-950/40" />

      <div className="relative z-10 mx-auto w-full max-w-7xl px-6 md:px-12 lg:px-20">
        <ScrollReveal>
          <div className="max-w-2xl">
            <span className="font-label text-xs tracking-[0.4em] text-accent-300">RECRUIT</span>
            <h2 className="mt-6 font-display text-3xl font-light leading-[1.7] tracking-[0.06em] text-background-50 md:text-5xl">
              挑戦するヒトが、
              <br />
              次の時代をつくる。
            </h2>
            <p className="mt-8 font-body text-sm leading-[2.2] text-background-300">
              私たちは、共に挑戦し、共に成長できる仲間を探しています。
              一人ひとりの可能性が花開く環境を、ここから創っていきます。
            </p>
            <Link
              to="/recruit"
              className="mt-10 inline-flex items-center gap-3 whitespace-nowrap bg-background-50 px-9 py-3.5 font-body text-[12px] tracking-[0.22em] text-foreground-950 transition-colors hover:bg-accent-500"
            >
              JOIN US
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}